import handleBase64ZipResponse from "../helpers/handleBase64ZipResponse";
import call from "./call";

export default (onFinishCallBack) => async (dispatch) =>
{
  const onResult= (result) =>
  {
    if(result && result[1].success) {
        handleBase64ZipResponse(result[1].result, "log.txt");
    }
  };
  dispatch(call("SystemService/getSystemLog",{},onResult));
};